import { RecommendationType } from '@/webapi/use-widget-catalog-api';
import { QBConnector, TimeframeUnit } from '@/components/query-builder/models';

export interface StoredManualProduct {
  id: string;
  title?: string;
  handle?: string;
  imageOverride?: string;
  image?: { src: string };
  images?: { src: string }[];
  price?: number;
  compareAtPrice?: number;
  inventoryQuantity?: string;
  mainValue?: string;
}

export interface StoredSlotFilter {
  qbProps: { envKey: string };
  values: Array<{ op: string; value: string; currency?: string }>;
  connector?: QBConnector;
  timeframe?: { value: number; unit: TimeframeUnit };
  autoApplyCurrency?: boolean;
  includeQueryParams?: boolean;
}

export interface StoredSlot {
  num: number;
  strategy?: RecommendationType;
  isGlobalFilter?: boolean;
  hash?: string;
  filter?: StoredSlotFilter[];
  manualProduct?: StoredManualProduct;
}

export enum ExternalStrategyType {
  UNKNOWN = 0,
  EMBED = 1,
  RECS = 2,
  UPSELLS = 3,
}

export interface ExternalStrategy {
  type: string;
  conditionId: string;
  respSize: number;
  condition: Record<string, any>[];
  strategyPerSlot: Record<string, any>[];
}

export interface ConnectedExperience {
  id: string;
  label: string;
}

export interface ExternalStrategyData {
  label: string;
  description: string;
  updatedAt: string;
  updatedBy: string;
  connectedExperiences: ConnectedExperience[];
  link: Record<string, any>;
}

export interface ExpandedExternalStrategy {
  strategyId: string;
  alias: string;
  strategy: ExternalStrategy;
  data: ExternalStrategyData;
  type: ExternalStrategyType | string | number;
}

export interface DeleteExternalStrategyReq {
  strategyId: string;
  alias: string;
}

export interface GetExternalStrategyReq {
  alias: string;
  strategyId: string;
}

export interface ListExternalStrategiesReq {
  alias: string;
  type?: ExternalStrategyType;
}

export interface ListExternalStrategiesResp {
  strategies: ExpandedExternalStrategy[];
}
